import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import checkNotAuthenticated from '@/router/middlewares/checkNotAuthenticated';
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';
import i18n from "../../language/i18n";

export default [
    {
        path: '/dashboard',
        name: i18n.t('Common.dashboard'),
        component: () => import(/* webpackChunkName: "dashboard" */ '@/modules/dashboard/components/DashboardForm'),
        beforeEnter: checkAuthenticated,
    }, 
    {
        path: '/login',
        name: 'LoginView',
        component: () => import(/* webpackChunkName: "login" */ '@/modules/login/components/LoginView.vue'),
        beforeEnter: checkNotAuthenticated,
    },
    {
        path: '/logout',
        name: 'LogoutView',
        component: () => import(/* webpackChunkName: "logout" */ '@/modules/login/components/LogoutView.vue'),
    },
    {
        path: '/openWindows',
        name: 'OpenWindowsView',
        component: () => import(/* webpackChunkName: "openwindows" */ '@/modules/open_windows/components/OpenWindowsView'),
        beforeEnter: checkAuthenticated
    },
    {
        path: '/navigation',
        name: 'NavigationView',
        component: () => import(/* webpackChunkName: "navigation" */ '@/modules/navigation/components/NavigationView'),
        beforeEnter: checkAuthenticated
    },
    {
        path: '/playground',
        name: i18n.t('Common.playground'),
        component: () => import(/* webpackChunkName: "playground" */ '@/dev/PlaygroundComponent'),
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/search',
        name: 'SearchView',
        component: () => import(/* webpackChunkName: "search" */ '@/modules/search/components/SearchView'),
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/user-profile',
        name: 'UserProfile',
        component: () => import(/* webpackChunkName: "userProfile" */ '@/modules/user_profile/UserProfile'),
        meta: {
            preloads: [
                'rights/actingUserHasRight/WORK_Profil_Arbeitsplatz_selber_pflegen',
                'rights/actingUserHasRight/WORK_Exchange_Mitarbeiter_Synchronisation'
            ],
            registries: ['configurations/profile'],
        },
        props: true,
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/notifications',
        name: 'NotificationsOverview',
        component: () => import(/* webpackChunkName: "messages-overview" */ '@/modules/notifications/components/NotificationsOverview'),
        meta: {
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
            moduleId: 'notifications',
            ignoreModuleCheck: true
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/notificationgroups',
        name: 'NotificationGroupsView',
        component: () => import(/* webpackChunkName: "messages-overview" */ '@/modules/notifications/components/NotificationGroupsView'),
        meta: {
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
            moduleId: 'notificationGroups',
            ignoreModuleCheck: true
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/notificationgroups/:id',
        name: 'NotificationGroupForm',
        component: () => import(/* webpackChunkName: "notification-group-form" */ '@/modules/notifications/components/NotificationGroupForm'),
        meta: { moduleId: 'notificationGroups' },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
]
